import { createActionTypes } from "@helpers/redux-helpers";

export const setFileUploadProgressActionTypes = "files/fileUploadProgress/set";
export const resetFileUploadProgressActionTypes =
  "files/fileUploadProgress/reset";
export const uploadMultipartFailureActionTypes =
  "files/fileUploadProgress/failure";

export const uploadFileActionTypes = createActionTypes("files/upload");
